module.exports = __webpack_public_path__ + "static/app icon.ea980cd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Curro/app icon.png
// module id = 515
// module chunks = 160870767912026